import { StatusHistoryState } from './models';

export const namespace = 'vtn-common-state-status-history';

export const defaultState: StatusHistoryState = {
  gate: 'unknown',
  schemaId: null,
  latestByTdoId: {},
  historyByTdoId: {},
  readVerifiedTdoIds: {},
};

export interface StatusHistoryStore {
  [namespace]: StatusHistoryState;
}
